import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardData } from '../data/types/CardData';
import { CreditCard } from 'data/shared/CreditCard';
import { SetStateAction, useCallback, useState, Dispatch, } from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { CreditCardData } from 'data/shared/CreditCardData';

export const CreditCardSearchBar = ({
  handleAddCard,
  selectedCards,
  handleRemoveCard,
  setSelectedCards,
}: {
  handleAddCard: (card: CreditCard) => void;
  handleRemoveCard: (card: CreditCard) => void;
  selectedCards: ReadonlyArray<CreditCard>;
  setSelectedCards: Dispatch<SetStateAction<CreditCard[]>>;
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState<
    ReadonlyArray<CardData>
  >([]);

  const [showSuggestions, setShowSuggestions] = useState(false);

  const filterValues = useCallback((value: string) => {
    const filtered = Object.values(CreditCardData).filter((card) =>
      card.name.toLowerCase().includes(value.toLowerCase())
    ).sort((a, b) => { 
      if (selectedCards.includes(a.id) && !selectedCards.includes(b.id)) {
        return -1;
      }
      if (!selectedCards.includes(a.id) && selectedCards.includes(b.id)) {
        return 1
      }
      if (!a.name) {
        return -1;
      }
      if (!b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0
    });
    return filtered;
  }, [selectedCards]);

    
  const handleInputChange = (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    setFilteredSuggestions(filterValues(value));
  };

  const handleSuggestionClick = useCallback((card: CreditCard) => {
    if (selectedCards.includes(card)) {
      handleRemoveCard(card);
    } else {
      handleAddCard(card);
      setTimeout(() => {
        // setSearchValue('');
        // setShowSuggestions(false);
      }, 100);
    }
  }, [handleAddCard, handleRemoveCard, selectedCards]);

  return (
    <div style={{ width: '100%', maxWidth: 800 }}>
      {showSuggestions && (
        // Invisible mask so clicking outside the suggestions closes them
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
          onClick={() => setShowSuggestions(false)}
        ></div>
      )}
      <input
        onFocus={() => {
          setShowSuggestions(true);
          setFilteredSuggestions(filterValues(searchValue));
        }}
        onBlur={() => {
          setTimeout(() => {
            setShowSuggestions(false);
          }, 100);
        }}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          borderRadius: 90,
          width: '100%',
          backgroundColor: '#fff',
          border: '2px solid #6488A3',
          zIndex: 1000,
        }}
        type="text"
        value={searchValue}
        onChange={handleInputChange}
        placeholder="🔍 Search for a credit card..."
      />
      {showSuggestions && (
        <ul
          style={{
            listStyle: 'none',
            padding: '0 12px 12px 12px',
            position: 'absolute',
            marginTop: '5px',
            backgroundColor: '#fff',
            borderRadius: 15,
            width: '100%',
            boxShadow: '0 20px 30px rgba(0, 0, 0, 0.25)',
            zIndex: 2,
            // height: 600,
            maxHeight: '80vh',
            overflowY: 'auto',
          }}
        >
          <div
            style={{
              position: 'sticky',
              paddingTop: '12px',
              paddingBottom: '12px',
              top: 0,
              backgroundColor: '#fff',
              display: 'flex',
              flexDirection: 'row-reverse',
              alignItems: 'center',
              gap: 10,
              justifyContent: 'space-between',
            }}
          >
            {/* <div>
              <button onClick={() => { setCardTypeFilter('all'); return false }}>
                All cards ({Object.values(CreditCardData).length})
              </button>
              <button onClick={() => { setCardTypeFilter('travel'); return false }}>Travel</button>
              <button onClick={() => { setCardTypeFilter('cashback'); return false }}>Cash back</button>
            </div> */}
            <button
              onClick={() => {
                setSelectedCards((cards) => []);
                return false;
              }}
            >
              Remove all
            </button>
            <p style={{ margin: 0 }}>
              {selectedCards.length} of {Object.values(CreditCardData).length}{' '}
              selected
            </p>
          </div>
          {filteredSuggestions.map((card) => (
            <button
              key={card.id}
              style={{
                border: 'none',
                background: 'none',
                display: 'block',
                fontSize: 'inherit',
                width: '100%',
              }}
              onClick={() => handleSuggestionClick(card.id)}
            >
              <li
                style={{
                  display: 'flex',
                  padding: '5px 10px',
                  borderRadius: 10,
                  flexDirection: 'row',
                  ...(selectedCards.includes(card.id) && {
                    backgroundColor: '#f0f0f0',
                  }),
                  alignItems: 'center',
                  gap: 10,
                }}
              >
                <span style={{ marginRight: 8 }}>
                  {selectedCards.includes(card.id) ? (
                    <FontAwesomeIcon icon={faCheck} />
                  ) : (
                    <div style={{ width: 16 }} />
                  )}
                </span>
                <img
                  width={50}
                  src={`cards/${card.imageName}`}
                  alt={card.name}
                />

                {card.name}
              </li>
            </button>
          ))}
          {filteredSuggestions.length === 0 && (
            // TODO: Add a checkbox when it's selected
            <li style={{ padding: '5px', color: '#999' }}>No suggestions</li>
          )}
        </ul>
      )}
    </div>
  );
};
